import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import { useEffect, useState, useRef } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import '../styles/noPrint.css'
import moment from "moment";
import { faDownload, faPaperPlane, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ApproverModal from "./ApproverModal";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
const PreviewDeliveryChallan = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const personId = searchParams.get('personId')
  const navigate = useNavigate();
  let id = (type == "challan" || type == "Externalchallan") ? searchParams.get('challanId') : location.state?.id
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([])
  const [rowData, setRowData] = useState([])
  const token = localStorage.getItem('token')
  const [profileDetails, setProfileDetails] = useState(null);
  const centerCode = localStorage.getItem('code')
  const email = localStorage.getItem('email')
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const pin = localStorage.getItem('pin');
  const sewadarId = localStorage.getItem('sewadarId')
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [selectedChallanId, setSelectedChallanId] = useState(null);
  const [showSignature, setShowSignature] = useState(false);
  const [personOptions, setPersonOptions] = useState([]);
  const [relatedChallanData, setRelatedChallanData] = useState(null);
  const [transhipCertificateText, setTranshipCertificateText] = useState("");
  const [normalCertificateText, setNormalCertificateText] = useState("");
  const [certificateText, setCertificateText] = useState("");

  useEffect(() => {
    fetchPersons();
  }, []);
  const closeModal = () => {
    setModalShow(false); // Close the modal
  };
  const handleDownloadPDF = async () => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;

      // Function to add footer to a page
      const addFooter = (pdf, pageNum) => {
        pdf.setPage(pageNum);
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(margin, pageHeight - margin - 10, pageWidth - margin, pageHeight - margin - 10);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          "H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India",
          pageWidth / 2,
          pageHeight - margin,
          { align: "center" }
        );
      };

      // Function to capture and add a challan to PDF
      const addChallanToPDF = async (elementId, isFirstPage = true) => {
        const element = document.getElementById(elementId);
        if (!element) return;

        // Create a temporary container for the element
        const tempContainer = document.createElement('div');
        tempContainer.style.width = '800px';
        tempContainer.style.margin = 'auto';
        tempContainer.style.padding = '10px';
        tempContainer.style.fontFamily = 'Arial, sans-serif';
        tempContainer.style.fontSize = '18px';
        tempContainer.style.backgroundColor = 'white';

        // Clone the element
        const clone = element.cloneNode(true);

        // Add footer to the cloned element
        // const footer = document.createElement('footer');
        // footer.style.cssText = `
        //   text-align: center;
        //   margin-top: 20px;
        //   font-size: 14px;
        //   border-top: 1px solid black;
        //   padding-top: 10px;
        //   font-weight: bolder;
        // `;
        // footer.textContent = "H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India";
        // clone.appendChild(footer);

        tempContainer.appendChild(clone);

        // Add to DOM temporarily
        tempContainer.style.position = 'fixed';
        tempContainer.style.left = '-9999px';
        tempContainer.style.top = '0';
        document.body.appendChild(tempContainer);

        try {
          const canvas = await html2canvas(tempContainer, {
            scale: 2,
            useCORS: true,
            allowTaint: false,
            backgroundColor: '#ffffff',
            logging: false
          });

          const imgData = canvas.toDataURL("image/png");
          const imgWidth = pageWidth - 2 * margin;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          // Add new page if not the first one
          if (!isFirstPage) {
            pdf.addPage();
          }

          // Add image to PDF
          pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);

        } finally {
          // Remove temporary container
          document.body.removeChild(tempContainer);
        }
      };

      // Add main challan
      await addChallanToPDF("main-challan-content", true);

      // Add related challan if exists
      if (relatedChallanData) {
        await addChallanToPDF("related-challan-content", false);
      }

      // Add footer to all pages
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        addFooter(pdf, i);
      }

      pdf.save("DeliveryChallan.pdf");

    } catch (error) {
      console.error('Error generating PDF:', error);
      Swal.fire('Error', 'Failed to generate PDF', 'error');
    }
  };
  const fetchPersons = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      });
      setPersonOptions(
        response.data.map((person) => ({
          value: person.id,
          label: `${person.firstName} ${person.lastName} - ${person.contactNo}`, // Assuming 'firstName' and 'lastName' are available
          mobileNo: person.contactNo,
          badgeId: person.badgeId
        }))
      );

    } catch (error) {
      console.error('Error fetching persons for approval:', error);
    }
  };
  const handleCancelRequest = () => {
    if (!token) {
      window.location.href = "/";
      return;
    }

    // Show confirmation dialog
    Swal.fire({
      title: 'Send Cancellation Request?',
      text: 'This will send a cancellation request to the approver via WhatsApp.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Send Request',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        sendCancellationRequest();
      }
    });
  };
  const sendCancellationRequest = async () => {
    try {
      // Find the authorized person from personOptions
      const authorizedPerson = personOptions.find(
        person => String(person.value) === String(rowData?.authorizedPersonId)
      );

      if (!authorizedPerson) {
        Swal.fire('Error', 'Authorized person not found.', 'error');
        return;
      }

      const mobileNo = authorizedPerson.mobileNo;

      // Generate the cancellation link
      const baseLink = `https://rs.iosystem.in/previewDeliveryChallan?id=${rowData?.id}`;
      const cancellationLink = `${baseLink}&challanId=${rowData?.id}&personId=${rowData?.authorizedPersonId}&type=challan&action=cancel`;

      // WhatsApp message
      const message = `Cancellation Request for Delivery Challan ${rowData?.prefix}${rowData?.refNo}\n\nPlease review and approve the cancellation:\n${cancellationLink}`;

      const whatsappLink = `https://wa.me/+91${mobileNo}?text=${encodeURIComponent(message)}`;

      // Open WhatsApp
      window.open(whatsappLink, "_blank");

      // Optional: Send cancellation request to backend
      await apiClient.post(
        `${SERVER_BASE}/sendCancellationRequest/${rowData?.id}`,
        {
          authorizedPersonId: rowData?.authorizedPersonId,

          type: 'Challan Cancellation'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Request Sent',
        text: 'Cancellation request has been sent to the approver.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });

    } catch (error) {
      console.error("Error sending cancellation request:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to send cancellation request. Please try again.',
      });
    }
  };

  const handleSendForApproval = (challanData) => {

    let challanId;
    if (challanData?.modeOfTransport == 'By Goods Transportation Agency') {
      challanId = challanData?.relatedDeliveryId
    }
    else {
      challanId = challanData?.id
    }

    if (!token) {
      window.location.href = "/";
    } else {
      setSelectedChallanId(challanId);
      setModalShow(true); // Show modal
    }
  };

  useEffect(() => {
    if (!token) {
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=challan`
      );


      return;
    }
    const fetchCenterInfo = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: { 'Authorization': `Bearer ${token}` },
        });

        const center = response.data[0];
        setData(center);

        if (center?.signature?.data) {
          const byteArray = new Uint8Array(center?.signature?.data);
          let binary = '';
          byteArray.forEach(byte => {
            binary += String.fromCharCode(byte);
          });
          const base64String = window.btoa(binary);
          setSignatureUrl(`data:image/jpeg;base64,${base64String}`);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };


    fetchCenterInfo();
  }, []);



  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);

    }
  };
  const handleModalSubmit = async (personId) => {
    const selectedPerson = personOptions.find(
      (person) => String(person.value) == String(personId)
    );
    const mobileNo = selectedPerson?.mobileNo;

    try {
      // API call to send for approval
      await apiClient.post(
        `${SERVER_BASE}/sendForApproval/${rowData?.id}`,
        { personId, type: 'Challan' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const baseLink = `https://rs.iosystem.in/previewDeliveryChallan?id=${selectedChallanId}`;
      const fullLink = `${baseLink}&challanId=${selectedChallanId}&personId=${personId}&type=challan`;
      const whatsappLink = `https://wa.me/+91${mobileNo}?text=${encodeURIComponent(
        `Check this Delivery Challan draft: ${fullLink}`
      )}`;
      window.open(whatsappLink, "_blank");

      setModalShow(false); // Close modal after successful submission
    } catch (error) {
      console.error("Error sending for approval:", error);
      setModalShow(false); // Close modal on error
    }
  };

  const handleApprove = () => {
    // SweetAlert2 for PIN input
    Swal.fire({
      title: 'Enter your PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter your PIN.';
        }
        if (value !== pin) {
          return 'Invalid PIN. Please try again.';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with the approval if PIN matches
        const approvedBy = name;
        const approvedByBadge = badgeId;

        // Send the approval request to the backend
        apiClient.post(`${SERVER_BASE}/approveChallan/${id}`, {
          approvedBy,
          approvedByBadge,
          refNo: rowData.refNo,
          prefix: rowData.prefix,
          itemDetails: rowData.itemDetails,
          maintainBalance: rowData?.maintainBalance
        })
          .then(response => {
            Swal.fire({
              icon: 'success',
              text: 'The voucher has been verified successfully.',
              position: 'top-end',
              toast: true,
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(err => {
            Swal.fire({
              toast: true,
              icon: 'error',
              title: 'Error',
              text: `Can't Approve: ${err.response?.data?.message || err.message}`,
              confirmButtonText: 'OK',
              width: '600px',   // ✅ increase width
            });
          });
      }
      // fetchDraftData();
    });
  };

  const removeDuplicateItems = (items) => {
    return [...new Map(
      items.map(item =>
        [`${item.itemName}|${item.quantity}|${item.uom}|${item.remarks}`, item]
      )
    ).values()];
  };
  useEffect(() => {
    const fetchRowData = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/viewDeliveryData`, {
          params: { id },
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.length > 0) {
          const data = response.data[0];

          if (Array.isArray(data.itemDetails)) data.itemDetails = removeDuplicateItems(data.itemDetails);

          setRowData(data);

          // fetch related tranship challan if exists
          if (data.relatedTranshipId) {
            const relatedResponse = await apiClient.get(`${SERVER_BASE}/viewDeliveryData`, {
              params: { id: data.relatedTranshipId },
              headers: { Authorization: `Bearer ${token}` },
            });

            if (relatedResponse.data.length > 0) {
              const relatedData = relatedResponse.data[0];
              if (Array.isArray(relatedData.itemDetails)) relatedData.itemDetails = removeDuplicateItems(relatedData.itemDetails);
              setRelatedChallanData(relatedData);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching challan data:', err);
      }
    };

    fetchRowData();
    fetchProfileDetails();
  }, []);

  if (!rowData) {
    return <p>No data available. Please go back to the list.</p>;
  }
  let desig = "";


  const designationText = `This is to certify that the goods listed below are the property of <strong>Radha Soami Satsang Beas</strong> and are being sent to <strong> ${relatedChallanData?.transporterName || ""
    }</strong> for further transship to <strong>${relatedChallanData?.ledger || ""
    }</strong>. These goods are being sent duly loaded in vehicle no. <strong>${relatedChallanData?.vehicleNo || ""
    }</strong> driven by <strong>${relatedChallanData?.name || ""
    }</strong> having Mobile no. <strong>${relatedChallanData?.mobileNo || ""
    }</strong>. These goods are not for the purpose of sale or any other commercial use. It is only for satsang use, therefore requested that these may please be allowed to proceed to its destination without any late or hindrance.`

  if (rowData?.receivedGoods == "Earlier Received on Returnable Basis") {
    desig = `This is to certify that goods below are the property of <strong>${rowData?.ledger || ""
      }</strong> and are being received in our satsang ghar for satsang use. The goods listed below are taken <strong>${rowData?.purpose || ""
      }</strong>. The same are being returned back to <strong>${rowData?.ledger || ""
      }</strong>. These goods are being sent loaded vehicle no. <strong>${rowData.vehicleNo || ""
      }</strong>, driven by <strong>${rowData.name || ""
      }</strong> having Mobile no. <strong>${rowData.mobileNo || ""
      }</strong>. These goods are not for the purpose of sale or any other commercial use. It is only for satsang use. It is therefore requested that these may please be allowed to proceed to their destination without any delay or hindrance.`;
  } else {
    desig = `This is to certify that the goods listed below are the property of Radha Soami Satsang Beas and are being sent to 
  <strong>${rowData?.ledger || ""}</strong> ${rowData?.purpose
        ? `, <strong>${rowData.purpose}</strong>`
        : ""
      }. These goods are being sent duly loaded in vehicle no. <strong>${rowData.vehicleNo || ""
      }</strong> driven by <strong>${rowData.name || ""
      }</strong> having Mobile no. <strong>${rowData.mobileNo || ""
      }</strong>. These goods are not for the purpose of sale or any other commercial use. It is therefore requested that these may please be allowed to proceed to its destination without any delay or hindrance.`
  }

  const organization = {
    name: data?.centerName,
    addressLine1: data?.addressLine1,
    addressLine2: data?.addressLine2,
    addressLine3: data?.addressLine3,
    mobile1: data?.mobile1,
    mobile2: data?.mobile2,
    gstin: data?.gstin,
    contactPerson1: data?.contactPerson1,
    contactPerson2: data?.contactPerson2,
    position1: data?.position1,
    position2: data?.position2
  };

  const challanInfo = {
    recipient: rowData?.recipient,
    recipientGSTIN: rowData?.recipientGSTIN,
    recipientAddress: rowData?.recipientAddress,
    purpose: rowData?.purpose,
    vehicleNo: rowData?.vehicleNo,
    driverName: rowData?.name,
    transporterName: rowData?.transporterName,
    transporterGSTIN: rowData?.transporterGSTIN,
    documentGRNo: rowData?.documentGRNo,
    documentGRDate: rowData?.documentGRDate,
    driverMobile: rowData?.driverMobile,
    receivedBy: rowData?.receivedBy,
    preparedBy: rowData?.preparedBy,
    verifiedBy: rowData?.verifiedBy,
    signatory: rowData?.signatory,
    FreightOn: rowData?.FreightOn,
    // designation: !rowData?.isTranshipment?desig: rowData?.ToWhomsoeverConcern,
    designation: rowData?.ToWhomsoeverConcern,
    freightDetails: rowData?.printFreight,
    totalFreight: rowData?.totalFreight,
    remarks: rowData?.consolidatedRemarks,
    approvedBy: rowData?.approvedBy,
    approvedByBadge: rowData?.approvedByBadge,
    createdBy: rowData?.createdBy,
    createdByBadge: rowData?.createdByBadge,
    modeOfTransport: rowData?.modeOfTransport,
    ledger: rowData?.ledger
  };

  const handleApproveCancel = async (rowData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel the Approved Challan? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Cancel it!",
      confirmButtonColor: '#d33',
    }).then(async (res) => {
      if (res.isConfirmed) {
        try {
          const response = await apiClient.post(`${SERVER_BASE}/cancelChallan/${rowData.id}`, {
            refNo: rowData.refNo,
            prefix: rowData.prefix,
            itemDetails: rowData.itemDetails,
            relatedTranshipId: rowData?.relatedTranshipId
          }, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          Swal.fire({
            icon: 'success',
            title: 'Cancellation Approved',
            text: 'The challan has been cancelled successfully.',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          }).then(() => {
            window.location.reload();
          });

        } catch (error) {
          console.error("Error approving cancellation:", error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to approve cancellation. Please try again.',
          });
        }
      }
    });
  };
  const handleRejectCancelChallan = () => {
    Swal.fire({
      title: 'Reject Cancellation?',
      text: 'Are you sure you want to reject this cancellation request?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Reject',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
    }).then((result) => {
      if (result.isConfirmed) {
        rejectCancelChallan();
      }
    });
  };
  const rejectCancelChallan = async () => {
    try {
      const response = await apiClient.post(
        `${SERVER_BASE}/rejectCancelChallan/${rowData?.id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Cancellation Rejected',
        text: 'The cancellation request has been rejected.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      }).then(() => {
        window.location.reload();
      });

    } catch (error) {
      console.error("Error rejecting cancellation:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to reject cancellation. Please try again.',
      });
    }
  };

  const itemDetails = rowData?.itemDetails || [];

  const remarks = rowData?.remarks || '';
  const footer = 'H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India';
  const handleSignatureImprint = async () => {

    // 👉 CLEAR SIGNATURE (no PIN, no API)
    if (showSignature) {
      setShowSignature(false);
      return;
    }

    // 👉 IMPRINT SIGNATURE (PIN + LOG)
    const pin = localStorage.getItem("pin");
    const doneBy = localStorage.getItem("sewadarId"); // or sewadarId / username

    if (!signatureUrl) {
      Swal.fire(
        "No signature found",
        "Please ensure signature is uploaded in center info.",
        "warning"
      );
      return;
    }

    const { isConfirmed } = await Swal.fire({
      title: "Enter your PIN",
      input: "password",
      inputPlaceholder: "Enter your PIN",
      showCancelButton: true,
      confirmButtonText: "Submit",
      inputValidator: (value) => {
        if (!value) return "Please enter your PIN.";
        if (value !== pin) return "Invalid PIN.";
        return null;
      },
    });

    if (!isConfirmed) return;

    try {
      const res = await apiClient.post(
        `${SERVER_BASE}/logSignatureImprint`,
        {
          voucherId: rowData.id,
          voucherNo: rowData.prefix + rowData.refNo,
          doneBy: sewadarId,
          voucherType: 'Delivery Challan'
        }
      );

      setShowSignature(true);
      // if (res.data.success) {
      //   Swal.fire({
      //     icon: "success",
      //     title: "Signature Imprinted",
      //     timer: 1200,
      //     toast:true,
      //     position:"top-end",
      //     t
      //     showConfirmButton: false,
      //   });
      // } else {
      //   Swal.fire("Error", "Unable to save imprint log", "error");
      // }
    } catch (err) {
      Swal.fire("Error", "Server error while saving log", "error");
    }
  };


  return (
    <>
      <div style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '800px', fontSize: '14px' }}>

        <div className="d-flex justify-content-between mb-3">
          {/* Back Button - Always visible */}
          {type != 'Externalchallan' && (
            <button className="btn btn-secondary no-print" onClick={() => window.history.back()}>
              Back
            </button>
          )}
          <div className="d-flex justify-content-between">
            {(rowData?.isApproved == 'Approved' && rowData?.cancellationStatus != 'Pending for Cancellation') &&
              <button className="btn btn-success no-print me-2" onClick={handleDownloadPDF}>
                <FontAwesomeIcon icon={faDownload} /> Download PDF
              </button>}
            {(
              !rowData?.prefix?.startsWith("JP/25-26/S-") &&
              rowData?.isApproved === "Approved" &&
              rowData?.cancellationStatus !== "Pending for Cancellation"
            ) && (
                <button
                  className="btn btn-primary no-print"
                  onClick={handleSignatureImprint}
                >
                  {showSignature ? "Clear Signature" : "Imprint Signature"}
                </button>
              )}



            {profileDetails &&
              rowData.isApproved !== 'Cancelled' &&
              rowData.isApproved == 'Approved' && rowData.cancellationStatus != 'Pending for Cancellation' && (
                <button
                  className="btn btn-danger ms-2 no-print"
                  onClick={handleCancelRequest}
                >
                  <FontAwesomeIcon icon={faTimesCircle} /> Cancel Challan
                </button>
              )}
            {profileDetails &&
              (String(profileDetails.id) == String(personId) ||
                String(profileDetails.id) == String(rowData?.authorizedPersonId)) &&
              rowData.cancellationStatus == 'Pending for Cancellation' && (
                <>
                  <button className="btn btn-success" onClick={() => handleApproveCancel(rowData)}>
                    Approve Cancel Request
                  </button>
                  <button className="btn btn-success" onClick={handleRejectCancelChallan}>
                    Reject
                  </button>
                </>
              )}
            {profileDetails &&
              String(profileDetails.id) !== String(personId) &&
              String(profileDetails.id) !== String(rowData?.authorizedPersonId) &&
              rowData.isApproved !== 'Approved' && rowData.isApproved !== 'Cancelled' && (
                <button className="btn btn-secondary me-2 no-print" onClick={() => handleSendForApproval(rowData)}>
                  <FontAwesomeIcon icon={faPaperPlane} /> Send for Verification
                </button>
              )}

            {profileDetails &&
              (String(profileDetails.id) === String(personId) ||
                String(profileDetails.id) === String(rowData?.authorizedPersonId)) &&
              rowData.isApproved !== 'Approved' && rowData.isApproved !== 'Cancelled' && (
                <button className="btn btn-success" onClick={handleApprove}>
                  Approve
                </button>
              )}
          </div>
        </div>
        <div id="main-challan-content" style={{ margin: 'auto', fontFamily: 'Arial, sans-serif', maxWidth: '800px', fontSize: '14px' }}>
          {(rowData.cancellationStatus === 'Pending for Cancellation' || rowData?.isApproved == 'Cancelled') && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-45deg)',
                fontSize: '60px',
                fontWeight: 'bold',
                color: 'rgba(255, 0, 0, 0.2)',
                zIndex: 1000,
                pointerEvents: 'none',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                width: '100%'
              }}
            >
              {(rowData?.cancellationStatus == 'Pending for Cancellation') ? `PENDING FOR CANCELLATION` : rowData?.isApproved == 'Cancelled' ? 'Cancelled Challan' : ''}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '12% 40% 48% ', alignItems: 'left', borderBottom: '1px solid black', paddingBottom: '10px' }}>
            <img src={RSSB_LOGO} alt="Logo" style={{ height: '80px' }} />
            <div style={{ textAlign: 'justify', fontSize: '12px' }}>
              <h5 style={{ margin: 0 }}>{organization?.name}</h5>
              <p style={{ margin: 0 }}>{organization?.addressLine1}</p>
              <p style={{ margin: 0 }}>{organization?.addressLine2}</p>
              <p style={{ margin: 0 }}>{organization?.addressLine3}</p>
              <p style={{ margin: 0 }}>Contact No: {organization.mobile1}{organization.mobile2 ? `, ${organization.mobile2}` : null }</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ margin: 0 }}>{organization?.contactPerson1}</p>
              <p style={{ margin: 0 }}>{organization?.position1}</p>
            </div>
          </div>

          {/* GST and Reference Section */}
          <div style={{ marginTop: '10px', fontSize: '14px', display: 'flex', justifyContent: 'space-between' }}>
            <p>GST NO: {organization?.gstin} <br />
              Ref.No: {rowData?.prefix}{rowData?.refNo}</p>
            <p>Date: {rowData?.date ? moment(rowData?.date).format('DD-MMM-YY') : ''}</p>
          </div>

          {/* Certificate Section */}
          <div style={{ fontSize: '14px', marginTop: '20px', textAlign: 'center', lineHeight: '1.6' }}>
            <h3 style={{ textDecoration: 'underline', marginBottom: '15px', fontSize: '19px', fontWeight: 'bolder' }}>TO WHOMSOEVER IT MAY CONCERN</h3>
            <div style={{ textAlign: 'justify' }}
              dangerouslySetInnerHTML={{
                __html: challanInfo.designation,
              }}
            ></div>
          </div>

          {rowData?.modeOfTransport == "Vehicle Itself" ? (

            <table
              style={{
                fontSize: '14px',
                width: '100%',
                marginTop: '40px',
                marginBottom: '40px',
                borderCollapse: 'collapse',
                border: '1px solid black',
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                  <th style={{ border: '2px solid black', padding: '5px' }}>S.No</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Type</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Vehicle No.</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Chassis</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Engine</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Insurance</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Policy</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Issued</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Expiry</th>
                </tr>
              </thead>
              <tbody>
                {[rowData?.vehicleDetails]?.filter(Boolean).map((vehicle, index) => (
                  <tr key={index} style={{ textAlign: 'left' }}>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{index + 1}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.vehicleType}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.vehicleNo}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.chassisNo}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.engineNo}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.insuranceCompany}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.policyNo}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.issueDate ? moment(vehicle.issueDate).format('DD-MMM-YY') : ''}</td>
                    <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.endDate ? moment(vehicle.endDate).format('DD-MMM-YY') : ''}</td>
                  </tr>
                ))}
              </tbody>

            </table>
          ) : (
            // Item Details Table (default)
            <table
              style={{
                fontSize: '14px',
                width: '100%',
                marginTop: '40px',
                marginBottom: '40px',
                borderCollapse: 'collapse',
                border: '1px solid black',
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                  <th style={{ border: '2px solid black', padding: '5px' }}>S.No</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Item Description</th>
                  <th className="text-center" style={{ border: '2px solid black', padding: '5px' }}>Quantity</th>
                  <th className="text-center" style={{ border: '2px solid black', padding: '5px' }}>UOM</th>
                  <th style={{ border: '2px solid black', padding: '5px' }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {(itemDetails || []).map((item, index) => (
                  <tr key={index} style={{ textAlign: "left" }}>
                    <td style={{ border: "2px solid black", padding: "5px" }}>{index + 1}</td>
                    <td style={{ border: "2px solid black", padding: "5px" }}>{item.itemName}</td>
                    <td className="text-center" style={{ border: "2px solid black", padding: "5px" }}>
                      {Number(item.quantity) % 1 === 0
                        ? parseInt(item.quantity)
                        : parseFloat(item.quantity).toFixed(2)}
                    </td>
                    <td className="text-center" style={{ border: "2px solid black", padding: "5px" }}>{item.uom}</td>
                    <td style={{ border: "2px solid black", padding: "5px" }}>{item.remarks}</td>
                  </tr>
                ))}
              </tbody>

            </table>
          )}


          <div>
            {challanInfo.freightDetails === "Yes" && (
              <div>
                <p>
                  {challanInfo.FreightOn == "On Sewa"
                    ? <p><b>VEHICLE ON SEWA</b> </p> : <p>Bilty of <b>{challanInfo.transporterName}</b> for <b> Rs.{challanInfo.totalFreight}/-</b> Vide GR No.<b>{challanInfo.documentGRNo}, </b> Dated <b> {challanInfo.documentGRDate}</b></p>
                  }
                </p>
              </div>
            )}

            {((rowData?.onAccount == 'Regular' || rowData?.onAccount == 'AHQ') && !rowData?.prefix?.endsWith('S-')) ? (
              <div className="text-left">
                <p><strong>नोट : </strong>कृपया इस चालान पर सिक्योरिटी सेवादार द्वारा चेक आउट सील लगवाकर ही वाहन को रवाना करें जी।</p>
              </div>
            ) : (rowData?.onAccount == 'Visit' || rowData?.prefix?.endsWith('S-')) ? (
              <div className="text-left">
                <p><strong>नोट : </strong>कृपया इस चालान पर एरिया ऑफिस एवं सिक्योरिटी सेवादार द्वारा चेक आउट सील लगवाकर ही वाहन को रवाना करें जी।</p>
              </div>
            ) : null}
            <p>Remarks:<b> {challanInfo.remarks}</b></p>
          </div>

          {/* Footer Section */}
          <div style={{ marginTop: '10px', fontSize: '15px', display: 'flex', justifyContent: 'space-between' }}>
            <p>Received By: {challanInfo.driverName} <br />
              Prepared By: {challanInfo.createdBy} {challanInfo.createdByBadge}<br />
              Verified By: {challanInfo.approvedBy} {challanInfo.approvedByBadge}</p>
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                textAlign: 'center',
                marginTop: '0px',
              }}
            >
              <p
                style={{
                  marginBottom: `${rowData?.prefix?.startsWith('JP/25-26/S-')
                      ? '75px'
                      : '7px'
                    }`
                }}
              >
                Radha Soami Satsang Beas
              </p>


              {showSignature && signatureUrl && (!rowData?.prefix.startsWith('JP/25-26/S-')) && (
                <img
                  src={signatureUrl}
                  alt="Signature"
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '140%',
                    height: '120px',
                    pointerEvents: 'none',
                    transform: 'rotate(-2deg)', // slight tilt for realism
                    opacity: 0.9, // blend effect
                  }}
                />
              )}


              <p style={{ fontWeight: 'bold' }}>Authorised Signatory</p>
            </div>


          </div>


          <ApproverModal
            show={modalShow}
            title="Send for Approval"
            options={personOptions}
            close={closeModal} // Pass close function
            onSubmit={handleModalSubmit}

          />
        </div>
        <footer className="footer" style={{
          textAlign: 'center',
          marginTop: '20px',
          fontSize: '14px',
          borderTop: '1px solid black',
          paddingTop: '10px',
          fontWeight: 'bolder'
        }}>
          {footer}
        </footer>

        {/* CSS for print media */}
        <style>
          {`
               /* Add this to your noPrint.css or within a style tag */
               @page {
                 margin: 0.5in;
                 size: A4;
                 
                 @bottom-center {
                   content: "H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India";
                   font-size: 15px;
                   font-weight: bolder;
                   border-top: 1px solid black;
                   padding-top: 1px;
                   width: 100%;
                 }
               }
               
               @media print {
                 .footer {
                   display: none; /* Hide HTML footer since we're using @page */
                 }
                 
                
                 table {
                   page-break-inside: auto;
                 }
                 
                 tr {
                   page-break-inside: avoid;
                   page-break-after: auto;
                 }
                 
                
                 .page-break {
                   page-break-before: always;
                 }
               }
              `}
        </style>
      </div>
      {relatedChallanData && (
        <div style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '800px', fontSize: '14px', pageBreakBefore: 'always' }}>

          <div id="related-challan-content" style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '800px', fontSize: '14px', pageBreakBefore: 'always' }}>
            {(relatedChallanData.cancellationStatus === 'Pending for Cancellation' || relatedChallanData?.isApproved == 'Cancelled') && (
              <div
                style={{
                  position: 'absolute',
                  top: '150%',
                  left: '51%',
                  transform: 'translate(-50%, -50%) rotate(-45deg)',
                  fontSize: '60px',
                  fontWeight: 'bold',
                  color: 'rgba(255, 0, 0, 0.2)',
                  zIndex: 1000,
                  pointerEvents: 'none',
                  whiteSpace: 'nowrap',
                  textAlign: 'center',
                  width: '100%',

                }}
              >
                {(relatedChallanData?.cancellationStatus == 'Pending for Cancellation') ? `PENDING FOR CANCELLATION` : relatedChallanData?.isApproved == 'Cancelled' ? 'Cancelled Challan' : ''}
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '12% 40% 50% ', alignItems: 'left', borderBottom: '1px solid black', paddingBottom: '10px' }}>
              <img src={RSSB_LOGO} alt="Logo" style={{ height: '80px' }} />
              <div style={{ textAlign: 'justify', fontSize: '12px' }}>
                <h5 style={{ margin: 0 }}>{organization?.name}</h5>
                <p style={{ margin: 0 }}>{organization?.addressLine1}</p>
                <p style={{ margin: 0 }}>{organization?.addressLine2}</p>
                <p style={{ margin: 0 }}>{organization?.addressLine3}</p>
                <p style={{ margin: 0 }}>Contact No: {organization.mobile1},{organization.mobile2}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ margin: 0 }}>{organization?.contactPerson1}</p>
                <p style={{ margin: 0 }}>{organization?.position1}</p>
              </div>
            </div>

            {/* GST and Reference Section */}
            <div style={{ marginTop: '10px', fontSize: '14px', display: 'flex', justifyContent: 'space-between' }}>
              <p>GST NO: {organization?.gstin} <br />
                Ref.No: {relatedChallanData?.prefix}{relatedChallanData?.refNo}</p>
              <p>Date: {relatedChallanData?.date ? moment(relatedChallanData?.date).format('DD-MMM-YY') : ''}</p>
            </div>

            {/* Certificate Section */}
            <div style={{ fontSize: '14px', marginTop: '20px', textAlign: 'center', lineHeight: '1.6' }}>
              <h3 style={{ textDecoration: 'underline', marginBottom: '15px', fontSize: '19px', fontWeight: 'bolder' }}>TO WHOMSOEVER IT MAY CONCERN</h3>
              <div style={{ textAlign: 'justify', lineHeight: '1.6', fontSize: '14px' }}
                dangerouslySetInnerHTML={{ __html: designationText }}>
              </div>

            </div>

            {relatedChallanData?.modeOfTransport == "Vehicle Itself" ? (

              <table
                style={{
                  fontSize: '14px',
                  width: '100%',
                  marginTop: '40px',
                  marginBottom: '40px',
                  borderCollapse: 'collapse',
                  border: '1px solid black',
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                    <th style={{ border: '2px solid black', padding: '5px' }}>S.No</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Type</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Vehicle No.</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Chassis</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Engine</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Insurance</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Policy</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Issued</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Expiry</th>
                  </tr>
                </thead>
                <tbody>
                  {[relatedChallanData?.vehicleDetails]?.filter(Boolean).map((vehicle, index) => (
                    <tr key={index} style={{ textAlign: 'left' }}>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{index + 1}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.vehicleType}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.vehicleNo}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.chassisNo}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.engineNo}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.insuranceCompany}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.policyNo}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.issueDate ? moment(vehicle.issueDate).format('DD-MMM-YY') : ''}</td>
                      <td style={{ border: '2px solid black', padding: '5px' }}>{vehicle.endDate ? moment(vehicle.endDate).format('DD-MMM-YY') : ''}</td>
                    </tr>
                  ))}
                </tbody>

              </table>
            ) : (
              // Item Details Table (default)
              <table
                style={{
                  fontSize: '14px',
                  width: '100%',
                  marginTop: '40px',
                  marginBottom: '40px',
                  borderCollapse: 'collapse',
                  border: '1px solid black',
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                    <th style={{ border: '2px solid black', padding: '5px' }}>S.No</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Item Description</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Quantity</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>UOM</th>
                    <th style={{ border: '2px solid black', padding: '5px' }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {(itemDetails || []).map((item, index) => (
                    <tr key={index} style={{ textAlign: "left" }}>
                      <td style={{ border: "2px solid black", padding: "5px" }}>{index + 1}</td>
                      <td style={{ border: "2px solid black", padding: "5px" }}>{item.itemName}</td>
                      <td style={{ border: "2px solid black", padding: "5px" }}>
                        {Number(item.quantity) % 1 === 0
                          ? parseInt(item.quantity)
                          : parseFloat(item.quantity).toFixed(2)}
                      </td>
                      <td style={{ border: "2px solid black", padding: "5px" }}>{item.uom}</td>
                      <td style={{ border: "2px solid black", padding: "5px" }}>{item.remarks}</td>
                    </tr>
                  ))}
                </tbody>

              </table>
            )}


            <div>
              {relatedChallanData.freightDetails === "Yes" && (
                <div>
                  <p>
                    {relatedChallanData.FreightOn == "On Sewa"
                      ? <p><b>VEHICLE ON SEWA</b> </p> : <p>Bilty of <b>{relatedChallanData.transporterName}</b> for <b> Rs.{relatedChallanData.totalFreight}/-</b> Vide GR No.<b>{relatedChallanData.documentGRNo}, </b> Dated <b> {relatedChallanData.documentGRDate}</b></p>
                    }
                  </p>
                </div>
              )}

              {((relatedChallanData?.onAccount == 'Regular' || relatedChallanData?.onAccount == 'AHQ') && !relatedChallanData?.prefix?.endsWith('S-')) ? (
                <div className="text-left">
                  <p><strong>नोट : </strong>कृपया इस चालान पर सिक्योरिटी सेवादार द्वारा चेक आउट सील लगवाकर ही वाहन को रवाना करें जी।</p>
                </div>
              ) : (relatedChallanData?.onAccount == 'Visit' || relatedChallanData?.prefix?.endsWith('S-')) ? (
                <div className="text-left">
                  <p><strong>नोट : </strong>कृपया इस चालान पर एरिया ऑफिस एवं सिक्योरिटी सेवादार द्वारा चेक आउट सील लगवाकर ही वाहन को रवाना करें जी।</p>
                </div>
              ) : null}
              <p>Remarks:<b> {relatedChallanData.consolidatedRemarks}</b></p>
            </div>

            {/* Footer Section */}
            <div style={{ marginTop: '10px', fontSize: '15px', display: 'flex', justifyContent: 'space-between' }}>
              <p>Received By: {relatedChallanData.name} <br />
                Prepared By: {relatedChallanData.createdBy} {relatedChallanData.createdByBadge}<br />
                Verified By: {relatedChallanData.approvedBy} {relatedChallanData.approvedByBadge}</p>
              <div
                style={{
                  position: 'relative',
                  display: 'inline-block',
                  textAlign: 'center',
                  marginTop: '0px',
                }}
              >
                <p
                  style={{
                    marginBottom: `${relatedChallanData?.prefix.startsWith('JP/25-26/S-')
                        ? '75px'
                        : '7px'
                      }`
                  }}
                >
                  Radha Soami Satsang Beas
                </p>

                {showSignature && signatureUrl && (!relatedChallanData?.prefix.startsWith('JP/25-26/S-')) && (
                  <img
                    src={signatureUrl}
                    alt="Signature"
                    style={{
                      display: 'block',
                      margin: '0 auto',
                      maxWidth: '140%',
                      height: '120px',
                      pointerEvents: 'none',
                      // transform: 'rotate(-2deg)', // slight tilt for realism
                      opacity: 0.9, // blend effect
                    }}
                  />
                )}


                <p style={{ fontWeight: 'bold' }}>Authorised Signatory</p>
              </div>

            </div>
          </div>
          <footer className="footer" style={{
            textAlign: 'center',
            marginTop: '20px',
            fontSize: '14px',
            borderTop: '1px solid black',
            paddingTop: '10px',
            fontWeight: 'bolder',

          }}>
            {footer}
          </footer>

          {/* CSS for print media */}
          <style>
            {`
    @media print {
      .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        border-top: 1px solid black;
        padding-top: 5px;
        font-weight: bolder;
        font-size: 14px;
      }
    }
  `}
          </style>
        </div>
      )}
    </>
  );
};

export default PreviewDeliveryChallan;
